import { useApi } from '@/api';
import {
  EntityName,
  IconKpiCard,
  KpiCard,
  Link,
  Page,
  PageSkeleton
} from '@/components';
import {
  CryptoIcon,
  Flex,
  Heading,
  LinkWrapper,
  NetworkIcon
} from '@blockanalitica/ui';
import HistoricTabs from './HistoricTabs';
export default function OptimismPage() {
  const [data, error] = useApi({
    url: '/optimism/'
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName symbol1={<NetworkIcon name="optimism" size="5" />}>
            <Heading size="1">
              <Flex gap="xs">Optimism</Flex>
            </Heading>
          </EntityName>
        }>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <IconKpiCard
            leftIcon={
              <EntityName
                symbol1={<CryptoIcon name={'USDS'} size="3" />}
                symbol2={<CryptoIcon name={'sUSDS'} size="3" />}>
                <></>
              </EntityName>
            }
            title="Total Circulating Assets"
            data={data}
            field="circulating_supply"
            options={{
              currencyValueOptions: { currency: 'USD' },
              linkArrow: false
            }}
          />
        </Flex>

        <HistoricTabs />
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <LinkWrapper
            to="/tokens/optimism/0x4f13a96ec5c4cf34e442b46bbd98a0791f20edc3"
            // @ts-ignore
            as={Link}
            variant="kpiCardLinkWithBlendMode">
            <KpiCard
              variant="usds"
              title="USDS circulating supply"
              field="usds_circulating_supply"
              data={data}
              options={{
                currency: 'USD',
                linkArrow: true
              }}
            />
          </LinkWrapper>
          <LinkWrapper
            to="/tokens/optimism/0xb5b2dc7fd34c249f4be7fb1fcea07950784229e0"
            // @ts-ignore
            as={Link}
            variant="kpiCardLinkWithBlendMode">
            <KpiCard
              variant="susds"
              title="sUSDS circulating supply"
              field="susds_circulating_supply"
              data={data}
              options={{
                currency: 'USD',
                linkArrow: true
              }}
            />
          </LinkWrapper>
        </Flex>
      </Page>
    );
  }
  return <PageSkeleton />;
}
